<template>
  <v-container
    tag="section"
  >
    <base-material-card
      color="coolrunner"
      icon="mdi-account"
      inline
      class="px-5 py-3"
    >
      <template v-slot:after-heading>
        <div class="text-h2 font-weight-light">
          {{ $tc('boarding', 99) }}
        </div>
      </template>
      <v-divider class="my-3" />
      <v-data-table
        :headers="headers"
        :items="items"
        :options.sync="options"
        :server-items-length="totalItems"
        :loading="loading"
        :footer-props="{
          itemsPerPageOptions: [10, 20, 50, 100]
        }"

        class="elevation-1"
      >
        <template v-slot:item.logo="{ item }">
          <div style="display: flex; align-items: center;">
            <img
              v-if="item.logo"
              :src="item.logo"
              style="max-width: 85px; max-height: 40px; padding: 10px 0;"
            >
          </div>
        </template>
        <template v-slot:item.action="{ item }">
          <v-row justify="end">
            <v-icon
              medium
              :disabled="loading"
              color="green"
              class="mr-2"
              @click="editItem(item)"
            >
              mdi-pencil
            </v-icon>
            <v-icon
              medium
              :disabled="loading"
              color="red"
              class="mr-5"
              @click="deleteItem(item)"
            >
              mdi-delete
            </v-icon>
          </v-row>
        </template>
      </v-data-table>
    </base-material-card>
    <v-dialog
      v-if="editedItem"
      v-model="dialog"
      max-width="768px"
      persistent
    >
      <v-card>
        <v-card-title style="display: flex; flex-direction: column; align-items: center; justify-content: center;">
          <img
            v-if="form.logo"
            :src="form.logo"
            height="40px"
          >
          <div
            v-else
            class="text-h5"
          >
            {{ form.title }}
          </div>
          <div
            v-if="form.$description"
            style="font-size: 16px;"
          >
            {{ form.$description }}
          </div>
        </v-card-title>

        <v-card-text
          style="padding: 5px;"
        >
          <v-container>
            <v-row dense>
              <base-form-builder
                v-for="(input, index) in form.inputs"
                :key="`${input.$type}_${input.$title}_${index}`"
                :field="input"
                :entity="editedItem"
                :errors="errors"
                @update:value="setValue"
              />
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            @click="close"
          >
            {{ $t('cancel') }}
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="save"
          >
            {{ $t('save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
  import List from '@/mixins/List'
  export default {
    mixins: [List],
    data: (vm) => ({
      endpoint: `customers/${vm.$route.params.id}/boardings`,
      name: 'boarding',
      dialog: false,
      editedItem: null,
      form: null,
      headers: [
        {
          value: 'logo',
          sortable: false,
        },
        {
          text: vm.$t('title'),
          value: 'title',
          width: '100%',
        },

        { text: vm.$t('actions'), value: 'action', align: 'right', sortable: false },
      ],
      slug: null,
      errors: null,
    }),
    computed: {
      params: function () {
        return this.disableQueryOptions ? {} : {
          limit: this.options.itemsPerPage,
          page: this.options.page,
          order_by: this.options.sortBy && this.options.sortBy[0] ? this.options.sortBy[0] : 'title',
          order_dir: this.options.sortDesc ? (this.options.sortDesc[0] === true || this.options.sortDesc[0] === undefined) ? 'desc' : 'asc' : 'desc',
          filters: this.filter,
        }
      },
    },

    methods: {
      editItem (item) {
        this.getForm(item.slug)
      },
      getForm: function (slug) {
        this.$get(`${this.endpoint}/${slug}`).then(r => {
          this.slug = slug
          const data = r?.data || {}

          this.form = { ...data?.form, logo: data.logo, title: data.title }
          this.buildItem(data.form)
          this.dialog = true
        })
      },
      buildItem: function (form, parent, errorsParent) {
        let item = parent ? { ...parent } : {}
        const errors = errorsParent ? { ...errorsParent } : {}
        const { inputs } = form
        if (!inputs || !inputs.length) return
        this.$_.each(inputs, input => {
          if (input.$type === 'group') { item = this.buildItem(input, item) } else {
            this.$_.set(item, input.$key, input.$value)
            errors[input.$key] = []
          }
        })
        if (!parent) {
          this.editedItem = item
          this.errors = errors
        } else return item
      },
      setValue: function ({ val, key }) {
        const item = { ...this.editedItem }
        this.$_.set(item, key, val)
        this.resetError(key)
        this.editedItem = item
      },
      resetError: function (key) {
        this.errors = { ...this.errors, [key]: [] }
      },
      save () {
        this.saving = true
        this.$post(`${this.endpoint}/${this.slug}`, this.editedItem, { useDev: this.useDev }).then(() => {
          this.getDataFromApi()
          this.$toast(`${this.$tc(this.name)} ${this.$t('saved_correctly')}`)

          this.close()
        })
          .catch(({ response }) => {
            const errors = response?.data?.errors || {}
            if (response.status === 422) { this.errors = { ...this.errors, ...errors } }
          })
          .finally(() => {
            this.saving = false
          })
      },
      deleteItem (item) {
        if (!this.canDelete()) { return }

        const index = this.$_.findIndex(this.items, c => c.id === item.id)

        if (prompt(this.$t('confirm_delete_prompt', { type: this.$tc(this.name).toLowerCase(), prompt: 'SLET' })) === 'SLET') {
          if (index >= 0) {
            this.$del(`/${this.endpoint}/${item.slug}`, undefined, { useDev: this.useDev }).then(() => {
              this.items.splice(index, 1)
              this.$toast(`${this.$tc(this.name)} ${this.$t('has_been_deleted')}`)
            })
          }
        }
      },

      close () {
        this.slug = null
        this.errors = null
        this.dialog = false
        this.editedItem = null
        this.form = null
      },
    },
  }
</script>
